import type { ProviderConfig } from "./types"

export const googleCalendarConfig: ProviderConfig = {
  sections: [
    {
      titleKey: "integrations_gcal_calendar",
      titleFallback: "Calendar",
      fields: [
        {
          kind: "select",
          key: "calendar_id",
          labelKey: "integrations_gcal_target",
          labelFallback: "Target calendar",
          options: [
            { value: "primary", label: "Primary" },
            { value: "work", label: "Work" },
          ],
        },
      ],
    },
    {
      titleKey: "integrations_gcal_sync",
      titleFallback: "Sync",
      fields: [
        {
          kind: "switch",
          key: "sync_trips",
          labelKey: "integrations_gcal_sync_trips",
          labelFallback: "Sync booked trips",
          descriptionKey: "integrations_gcal_sync_trips_desc",
          descriptionFallback: "Automatically add booked trips as calendar events",
        },
      ],
    },
  ],
}
